/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spaces[3],
    paddingVertical: theme.spaces[2]
  },
  contentContainer: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: theme.radius.md,
    ...TwTheme.values.shadows.cardInfo,
    padding: theme.spaces[3]
  },
  image: {
    height: 64,
    width: 64
  }
});
